import { IAssetTransactionSlides } from './types';
import type { RootState } from 'model/Redux';
import { Selector } from 'reselect';

export const assetTransactionSlidesSelector: Selector<RootState, IAssetTransactionSlides> = state => state.assetTransactionSlides.data;